import {
  Breadcrumbs as MUIBreadcrumbs,
  Link,
  Typography,
} from "@material-ui/core";
import { withRouter } from "components/UtilsComponent/ComponentWithRouterProp";
import { NavigateNext } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Breadcrumbs = (props: any) => {
  const { t } = useTranslation("breadcrumbs");
  const { navigate, location } = props.router;
  const pathnames = location?.pathname?.split("/").filter((x: string) => x);

  return (
    <MUIBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNext fontSize="small" />}
    >
      {pathnames?.map((name: string, index: number) => {
        let routeTo = `/${pathnames?.slice(0, index + 1).join("/")}`;

        if (routeTo === "/app") routeTo = "/app/dashboard";
        if (name === "app") name = "Home";
        if (name === "not-found") name = "Not Found";
        if (name === "access-denied") name = "Access Denied";

        const isLast = index === pathnames?.length - 1;
        return isLast ? (
          <Typography key={name} style={{ cursor: "default" }}>
            {t(name)}
          </Typography>
        ) : (
          <Link
            style={{ cursor: "pointer" }}
            key={name}
            onClick={() => navigate(routeTo)}
          >
            {t(name)}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default withRouter(Breadcrumbs);
